module.exports = __webpack_public_path__ + "static/media/technology-partnership-bg.a24434b8.jpg";